import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { toast } from 'react-toastify';
import { ENV } from '../../config/config';

// Custom base query with error handling
const baseQuery = fetchBaseQuery({
  baseUrl: ENV.url,
  prepareHeaders: (headers, { getState }) => {
    // Get token from localStorage
    const token = localStorage.getItem('accessToken');
    
    // Set common headers
    headers.set('x-auth-token', ENV.x_auth_token);
    
    if (token) {
      headers.set('Authorization', ENV.Authorization());
      headers.set('x-access-token', token);
    }
    
    return headers;
  },
});

// Custom base query with response transformation
const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  
  // Handle response transformation
  if (result.data) {
    const response = result.data;
    
    // Check if the API follows the { success, message, data } pattern
    if (typeof response === 'object' && 'success' in response) {
      if (response.success) {
        // Show success toast if message exists and method is not GET
        if (response.message && args.method !== 'GET') {
          toast.success(response.message);
        }
        // Transform to return just the data
        result.data = response.data !== undefined ? response.data : response;
      } else {
        // Handle error response
        if (response.message) {
          toast.error(response.message);
        }
        result.error = {
          status: 'CUSTOM_ERROR',
          data: response,
        };
      }
    }
  }
  
  // Handle fetch errors
  if (result.error) {
    const { status, data } = result.error;
    
    if (status === 'CUSTOM_ERROR') {
      // Already handled above
      return result;
    }
    
    // Handle network or other errors
    if (data?.message) {
      toast.error(data.message);
    } else if (status === 'FETCH_ERROR') {
      toast.error('Network error. Please check your connection.');
    }
  }
  
  return result;
};

// Create the base API
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Dashboard',
    'Admin',
    'Admins',
    'Event',
    'Events',
    'Gallery',
    'Categories',
    'Documents',
    'TeamMembers',
    'Slider',
    'About',
    'Content',
    'Settings',
    'Roles',
    'Role',
    'Permission',
  ],
  endpoints: () => ({}),
});

